import * as React from 'react';

function SvgCheckIn(props) {
  return (
    <svg width={24} height={25} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path opacity={0.01} fill="#000" d="M0 1.071h21.929V23H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.578 10.025l8.224-4.568 8.223 4.568v11.878H6.578V10.025z"
        fill="#FCCE01"
      />
      <path
        d="M11.014 16.48L8.03 13.495a1.08 1.08 0 00-1.007-.327c-.307.08-.45.327-.531.603-.082.278.081.775.371 1.024l1.602 1.508H2.233c-.362 0-.698.127-.878.44a1.015 1.015 0 000 1.016c.18.313.516.414.878.414h6.231l-1.602 1.555c-.257.255-.467.713-.371 1.023.097.31.287.45.557.525.269.073.724-.004.981-.26l3.046-3.045a1.014 1.014 0 00-.06-1.491z"
        fill="#4C4C4C"
      />
      <path
        d="M15.39 21.303c-.363 0-.698-.194-.88-.508-.182-.313-.182-.537 0-.852.182-.313.517-.506.88-.506h3.213L18.538 8.83l-7.574-4.495-7.899 4.497v2.485c0 .56-.365.969-.926.969-.563-.002-.92-.409-.92-.969V8.271c0-.35.178-.676.476-.862l8.73-4.995c.329-.206.747-.206 1.077 0l8.42 4.995c.297.186.479.511.478.864l.064 12.015c0 .56-.454 1.015-1.016 1.015h-4.06.001z"
        fill="#4C4C4C"
      />
    </svg>
  );
}

export default SvgCheckIn;
